import React from 'react'
import classnames from 'classnames'
import { Button } from './..'
import { Times as TimesSvg } from '../Svg'
import styles from './CloseButton.module.scss'

export interface CloseButtonProps {
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const CloseButton = ({ className, onClick }: CloseButtonProps) => (
  <Button
    className={classnames(styles.closeButton, className)}
    onClick={onClick}
  >
    <TimesSvg alt='close' />
  </Button>
)

export default CloseButton
